import React from 'react';
import NavBar from '../Landing2/NavBar';
import Footer from '../Landing2/Footer';
import Seo from '../Seo/Seo';

function NotFound() {
    return (
        <div>
            <Seo title="Page not found | Screenplayer" noindex />
            <NavBar />
            <section className="section" style={{backgroundColor: 'white'}}>
                <div className="container-large">
                    <h1>Page not found</h1>
                    <p>This page doesn't exist. <a href="/">Go to the Screenplayer homepage</a> or <a href="/blog">read the blog</a>.</p>
                </div>
            </section>
            <Footer />
        </div>
    );
}

export default NotFound;
